const hoverImageList = () => {
    // Only need to find a single Hover Image List since the CSS Variables are updated on the <body>
    const hoverImageLists = document.querySelectorAll('[data-hover-image-list]');
    hoverImageLists.forEach((hoverImageList) => {
        let animation, timer;
        const boundingClientRect = hoverImageList.getBoundingClientRect();
        const images = hoverImageList.querySelectorAll('.item__image img');
        const data = {
            delay: 8,
            mouseX: 0,
            mouseY: 0,
            _x: boundingClientRect.left,
            _y: boundingClientRect.top,
            endX: hoverImageList.offsetWidth / 2,
            endY: hoverImageList.offsetHeight / 2,
        };
        const animateDotOutline = () => {
            data._x += (data.endX - data._x) / data.delay;
            data._y += (data.endY - data._y) / data.delay;
            hoverImageList.style.setProperty('--trail-y', data._y + 'px');
            hoverImageList.style.setProperty('--trail-x', data._x + 'px');
            animation = requestAnimationFrame(animateDotOutline);
        };
        const tiltLeft = () => {
            images.forEach((image) => {
                image.style.setProperty('--rotateY', '-13deg');
            });
        };
        const tiltRight = () => {
            images.forEach((image) => {
                image.style.setProperty('--rotateY', '13deg');
            });
        };
        const tiltUp = () => {
            images.forEach((image) => {
                image.style.setProperty('--rotateX', '-13deg');
            });
        };
        const tiltDown = () => {
            images.forEach((image) => {
                image.style.setProperty('--rotateX', '13deg');
            });
        };
        const mouseStopped = () => {
            images.forEach((image) => {
                image.style.setProperty('--rotateX', '0deg');
                image.style.setProperty('--rotateY', '0deg');
            });
        };
        hoverImageList.addEventListener('mousemove', (e) => {
            data.endX = e.pageX;
            data.endY = e.pageY;
            if (e.pageX >= data.mouseX) {
                tiltRight();
            }
            else {
                tiltLeft();
            }
            // if (e.pageY >= data.mouseY) {
            //   tiltUp();
            // } else {
            //   tiltDown();
            // }
            data.mouseX = e.pageX;
            data.mouseY = e.pageY;
            clearTimeout(timer);
            timer = setTimeout(mouseStopped, 200);
        });
        hoverImageList.addEventListener('mouseenter', () => {
            animateDotOutline();
        });
        hoverImageList.addEventListener('mouseleave', () => {
            cancelAnimationFrame(animation);
        });
    });
};
export { hoverImageList };
